"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FromTo = void 0;
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var react_1 = __importDefault(require("react"));
var transifex_1 = require("../../transifex");
var FromTo = function (_a) {
    var from = _a.from, to = _a.to, _b = _a.icon, icon = _b === void 0 ? react_1.default.createElement(icons_1.ArrowRightOutlined, { style: { color: "gray" } }) : _b, short = _a.short;
    return (react_1.default.createElement(antd_1.Space, { size: 6, wrap: true },
        !short && from && transifex_1.TX_FROM,
        from,
        from && icon,
        " ",
        to && !short && transifex_1.TX_TO,
        to));
};
exports.FromTo = FromTo;
